import styled from '@emotion/styled';
import React from 'react';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { Color } from '@diritto/common/style/color';
import { convertToDotString } from '@diritto/common/utils/date';
import { ContentDetailInfoButton } from 'app-components/contents/detail/ContentDetailInfoButton';
import { DetailInfoMetaData, DetailInfoMetaDescription } from 'app-components/contents/detail/ContentDetailInfoMeta';
import { CalendarIcon } from 'icons/CalendarIcon';
import { DescriptionBlock } from 'ui-components/common/DescriptionBlock';
import { ContentCover } from 'ui-components/contents/ContentCover';

export type ContentDetailInfoProps = {
  content: ContentPublicRelayDto;
  profile?: ProfileLitePublicRelayDto;
};

export const ContentDetailInfo = ({ content, profile }: ContentDetailInfoProps) => (
  <>
    <StyledWrapper>
      <section>
        <StyledContentCover content={content} canEnlarge />
      </section>
      <StyledContentDetailItemMeta>
        <DetailInfoMetaData content={content} profile={profile} />
      </StyledContentDetailItemMeta>
    </StyledWrapper>
    <DetailInfoMetaDescription description={content.description} keywords={content.keywords} />
    <StyledContentDetailInfoButton contentId={content.id} />
    <StyledDescriptionBlockWrapper>
      {content.isHiddenContents && <DescriptionBlock message="공지 외 회차는 작가의 한마디, 댓글만 볼 수 있어요." />}
      {!content.isHiddenContents && content.reservedHideContentsAt && (
        <DescriptionBlock
          message={`${convertToDotString(content.reservedHideContentsAt)}까지 볼 수 있는 작품이에요.`}
          color={Color.Primary500}
          bgColor={Color.Primary100}
          icon={<CalendarIcon size={16} color={Color.Primary500} />}
        />
      )}
      {!content.isHiddenContents && !content.isFancyShareEnabled && (
        <DescriptionBlock message="이미지로 멋지게 공유하기를 할 수 없는 작품이에요." />
      )}
    </StyledDescriptionBlockWrapper>
  </>
);

const StyledContentCover = styled(ContentCover)``;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

const StyledContentDetailItemMeta = styled.section`
  flex: 1 0;
  margin-left: 16px;
`;

const StyledContentDetailInfoButton = styled(ContentDetailInfoButton)`
  margin-top: 24px;
`;

const StyledDescriptionBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;

  :empty {
    display: none;
  }
`;
